import { ErrorParameter, SorryMessageState } from '.';
import { MessageDisplayMethodInfo } from '../../../external/MessageDisplayMethodListApi';
import { MessageInfo } from '../../../external/MessageListApi';

export const MESSAGE_TYPE = {
  SNACKBAR: 'Snackbar',
  TOAST: 'Toast',
  SORRY: 'Sorry',
  NONE: '',
};

// 'default' | 'white' | 'info' | 'success' | 'warning' | 'error' | '';
export const SNACKBAR_TYPE = {
  ERROR: 'white',
  DEFAULT: 'default',
  INFO: 'info',
  NONE: '',
};

export const DISPLAY_METHOD_CD = {
  TOAST: '10',
  SNACKBAR_RED: '20',
  SNACKBAR_GR: '21',
  NONE: '',
};

export const API_CODE = {
  AP006: 'AP006',
  AP014: 'AP014',
  AP017: 'AP017',
  AP039: 'AP039',
  AP040: 'AP040',
  AP041: 'AP041',
  AP042: 'AP042',
  AP043: 'AP043',
  AP044: 'AP044',
  AP045: 'AP045',
  AP046: 'AP046',
  AP047: 'AP047',
  AP048: 'AP048',
  AP049: 'AP049',
  AP050: 'AP050',
  AP064: 'AP064',
  AP066: 'AP066',
  AP067: 'AP067',
  AP076: 'AP076',
  AP105: 'AP105',
  AP110: 'AP110',
  AP122: 'AP122',
  AP123: 'AP123',
  DEFAULT: 'DEFAULT',
};

export const API_STATE = {
  FETCH_CUSTOMER: 'FETCH_CUSTOMER',
  CREATE_CUSTOMER: 'CREATE_CUSTOMER',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  DELETE_CUSTOMER: 'DELETE_CUSTOMER',
  FETCH_ACTION: 'FETCH_ACTION',
  CREATE_ACTION: 'CREATE_ACTION',
  UPDATE_ACTION: 'UPDATE_ACTION',
  DELETE_ACTION: 'DELETE_ACTION',
  CREATE_NEGOTIATION: 'CREATE_NEGOTIATION',
  FETCH_NEGOTIATION: 'FETCH_NEGOTIATION',
  UPDATE_NEGOTIATION: 'UPDATE_NEGOTIATION',
  DELETE_NEGOTIATION: 'DELETE_NEGOTIATION',
  FETCH_PRODUCT: 'FETCH_PRODUCT',
  CREATE_PRODUCT: 'FETCH_PRODUCT',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  MAIL_SEND: 'MAIL_SEND',
  MAIL_TEMPLATE_APPLY: 'MAIL_TEMPLATE_APPLY',
  GET_MAIL_OPTIN_INFO: 'GET_MAIL_OPTIN_INFO',
  SESSION: 'SESSION',
  MAIL_OPT_IN_INFO: 'MAIL_OPT_IN_INFO',
  GET_HNDL_ITM_MNG_LIST: 'GET_HNDL_ITM_MNG_LIST',
  GET_VISIT_SUMMARY: 'GET_VISIT_SUMMARY',
  CHECK_ACTION_NUM: 'CHECK_ACTION_NUM',
  DEFAULT: 'DEFAULT',
};

export interface ErrorDetail {
  messageType: string;
  SnackbarType: string;
  tilet: string;
  message: string;
}

export function getErrorDetail(state: SorryMessageState, payload: ErrorParameter): ErrorDetail {
  const errorDetail: ErrorDetail = {
    messageType: MESSAGE_TYPE.SORRY,
    SnackbarType: SNACKBAR_TYPE.NONE,
    tilet: 'システムエラー',
    message: 'システムエラーが発生しました。しばらく経ってからやり直してください。',
  };

  if (payload.result.resultMessageDtoList) {
    errorDetail.message = payload.result.resultMessageDtoList[0].resultMessage;
    if (state.messageDisplayMethodList) {
      if (getMessageMethodFromMasterInfo(state.messageDisplayMethodList) && state.messageMstList) {
        errorDetail.message = getMessageFromMasterInfo(state.messageMstList, payload.result.resultMessageDtoList[0].resultMessageCd);
      }

      const messa1ge = getdisplayItemFromMasterInfo(
        state.messageDisplayMethodList,
        payload.functionId,
        payload.apiState,
        payload.result.resultMessageDtoList[0].resultMessageCd
      );
      if (messa1ge) {
        switch (messa1ge.messageDisplayMethodCode) {
          case DISPLAY_METHOD_CD.TOAST:
            // errorDetail.messageType = MESSAGE_TYPE.TOAST;
            errorDetail.messageType = MESSAGE_TYPE.SNACKBAR;
            errorDetail.SnackbarType = SNACKBAR_TYPE.ERROR;
            break;
          case DISPLAY_METHOD_CD.SNACKBAR_RED:
            errorDetail.messageType = MESSAGE_TYPE.SNACKBAR;
            errorDetail.SnackbarType = SNACKBAR_TYPE.DEFAULT;
            break;
          case DISPLAY_METHOD_CD.SNACKBAR_GR:
            errorDetail.messageType = MESSAGE_TYPE.SNACKBAR;
            errorDetail.SnackbarType = SNACKBAR_TYPE.INFO;
            break;
          default:
            break;
        }
      }
    }
  }
  return errorDetail;
}

function getMessageMethodFromMasterInfo(messageDisplayMethodMst: Array<MessageDisplayMethodInfo>): boolean {
  if (!messageDisplayMethodMst) {
    return false;
  }

  // MessageInfo取得
  const messageInfo = messageDisplayMethodMst.find(
    (messageItem) => messageItem.messageDisplayMethodCode === '00' && messageItem.functionId === '000000'
  );
  return messageInfo ? true : false;
}

function getdisplayItemFromMasterInfo(
  messageDisplayMethodMst: Array<MessageDisplayMethodInfo>,
  functionId: string,
  apiState: string,
  messageId: string
): MessageDisplayMethodInfo | undefined {
  if (!messageDisplayMethodMst) {
    return undefined;
  }

  // MessageInfo取得
  let messageInfo = messageDisplayMethodMst.find(
    (messageItem) => messageItem.messageId === messageId && messageItem.apiState === apiState && messageItem.functionId === functionId
  );

  // DEFAULT取得
  if (!messageInfo) {
    messageInfo = messageDisplayMethodMst.find(
      (messageItem) =>
        messageItem.messageId === messageId && messageItem.apiState === API_STATE.DEFAULT && messageItem.functionId === API_CODE.DEFAULT
    );
  }

  return messageInfo;
}

function getMessageFromMasterInfo(messageList: Array<MessageInfo>, messageId: string): string {
  if (!messageList) {
    return '';
  }

  // MessageInfo取得
  const messageInfo = messageList.find((messageItem) => messageItem.messageId === messageId);
  return messageInfo ? messageInfo.message : '';
}
